import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import MainPage from "../pages/MainPage";

const HomePage = lazy(() => import("../pages/HomePage"));
const CategoryPage = lazy(() => import("../pages/CategoryPage"));
const StudentWorksheetPage = lazy(() => import("../pages/StudentWorksheetPage"));
const CollagePage = lazy(() => import("../pages/CollagePage"));
const IdCardCombine = lazy(() => import("../pages/IdCardPage"));

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/id-card" element={<IdCardCombine />} />
      <Route path="/collages" element={<CollagePage />} />

      <Route path="/custom-layout" element={<HomePage />} />
      <Route path="/ai-collage-maker" element={<StudentWorksheetPage />} />

      {/* <Route path="/worksheets/:name/:id" element={<CategoryPage />} /> */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="*" element={<Navigate to="/" />} />

    </Routes>
  );
};

export default AppRoutes;